// src/componentes/AnimatedPage.js
import { motion } from 'framer-motion';

const animations = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0},
  exit: { opacity: 0, y: -30 },
};

export default function AnimatedPage({ children }) {
  return (
    <motion.div
      variants={animations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2 }}
    >
      {children}
    </motion.div>
  );
}
